// $media_lg: 1200px;
// $media_md: 992px;
// $media_sm: 768px;
// $media_xs: 576px;

export default {
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      media_lg: 1200,
      media_md: 992,
      media_sm: 768,
      media_xs: 576,
      media_mobile: 360,
    };
  },
  created() {
    if (process.client) {
      window.addEventListener('resize', this.handleResize)
    }
    this.handleResize();
  },
  destroyed() {
    if (process.client) {
      window.removeEventListener('resize', this.handleResize)
    }
  },
  methods: {
    handleResize:function () {
      if (process.client) {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      }
    }

  }
};



// WEBPACK FOOTER //
// ./components/shared/mixins/ScreenMixin.js